import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment/moment";
import Utils from "../../../../utils/utils";

class ModalDetailRegisterBus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addressHome: '',
            busStopRes: null,
            busTypeRes: null,
            discount: 0,
            endDay: 0,
            fullName: "",
            payment: 0,
            priceType: 0,
            reasonDiscount: "",
            startDay: null,
            state: "ACTIVE"
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState(nextProps.item)
        }
    }
    getStateUserReg(state){
        if (state == "CANCEL"){
            return <span className="badge badge-danger" style={{color: "white"}}>Đã hủy</span>
        }else if (state == "NEW_REGISTER"){
            return <span className="badge bg-primary" style={{color: "white"}}>Đăng ký mới</span>
        }else if (state == "ACTIVE"){
            return <span className="badge badge-info" style={{color: "white"}}>Hoạt động</span>
        }else if (state == "PAID"){
            return <span className="badge badge-success" style={{color: "white"}}>Đã thanh toán</span>
        }else if (state == "INACTIVE"){
            return <span className="badge badge-dark" style={{color: "white"}}>Đã khóa</span>
        }
    }
    getEndDate() {

    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-normal">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Chi tiết đăng ký dịch vụ xe bus</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Tên học sinh</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.fullName}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Trạng thái</label>
                                    <label className="col-8 label-item pl-0"><b>{this.getStateUserReg(this.state.state)}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Ngày bắt đầu</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.startDay == "Invalid date" ? null : moment(this.state.startDay).format("DD-MM-YYYY")}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Ngày hủy</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.endDay == "Invalid date" ? null : moment(this.state.endDay).format("DD-MM-YYYY")}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Ngày kết thúc</label>
                                    <label className="col-8 label-item pl-0"><b>{this.getEndDate()}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Số tháng đăng ký</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.priceType} tháng</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-2 label-item pl-0">Loại dịch vụ</label>
                                    <label className="col-10 label-item pl-0"><b>{this.state.busTypeRes?.name}({Utils.formatMoney(this.state.busTypeRes?.price)}đ)</b></label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-2 label-item pl-0">Điểm đón</label>
                                    <label className="col-10 label-item pl-0"><b>{this.state.busStopRes?.name}</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Đã thanh toán</label>
                                    <label className="col-8 label-item pl-0"><b>{Utils.formatMoney(this.state.payment)}đ</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Tổng tiền</label>
                                    <label className="col-8 label-item pl-0"><b>{Utils.formatMoney(this.state.busTypeRes?.price*this.state.priceType-this.state.discount)} đ</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Khấu trừ</label>
                                    <label className="col-8 label-item pl-0"><b>{Utils.formatMoney(this.state.discount)}đ</b></label>
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Lý do</label>
                                    <label className="col-8 label-item pl-0"><b>{this.state.reasonDiscount}</b></label>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalDetailRegisterBus